import { gql } from "@apollo/client";

// Resolves a client's installed base root for CreateGridModal. The clientId
// filter matches nothing on installedBaseRootNodeList, but it works on
// installedBaseNodeList; CLIENT nodes are always roots, one per client
// (testing, 2026-10-28). Never search the full root list instead: it is
// unpaginated and loads thousands of companies for a global admin.
export const GridClientRootNode = gql`
    query GridClientRootNode($clientId: ID!) {
        installedBaseNodeList(filter: {clientId: {equals: $clientId}, nodeTypeKey: {equals: CLIENT}}) {
            installedBaseNodes {
                id
                title
                childrenNodeCount
            }
        }
    }
`;

// Only for a grid view without client: does the user see any root at all?
// Selecting just the total keeps the unpaginated list cheap.
export const GridVisibleRootCount = gql`
    query GridVisibleRootCount {
        installedBaseRootNodeList(filter: {}) {
            total
        }
    }
`;
